import React from 'react';
import { ArrowLeft, FileCheck2, Printer } from 'lucide-react';
import { Link } from 'react-router-dom';

export const HomeSmartLegalLayout = ({ title, subtitle, version, children, testId }) => (
  <main className="min-h-screen bg-[#f0f4fa] px-4 py-8 text-[#0a2c5c] sm:py-14" data-testid={testId}>
    <div className="mx-auto max-w-4xl">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Link to="/home-smart/registrazione" className="inline-flex items-center gap-2 text-sm font-bold text-[#1947C7] hover:text-[#1337a3]" data-testid={`${testId}-back-link`}>
          <ArrowLeft className="h-4 w-4" /> Torna alla registrazione
        </Link>
        <button type="button" onClick={() => window.print()} className="inline-flex items-center gap-2 text-sm font-bold text-[#1947C7] hover:text-[#1337a3]" data-testid={`${testId}-print-button`}>
          <Printer className="h-4 w-4" /> Stampa o salva PDF
        </button>
      </div>
      <article className="mt-6 overflow-hidden rounded-lg border border-[#dbe5f3] bg-white shadow-xl">
        <header className="bg-[#08234c] px-6 py-10 text-white sm:px-10">
          <div className="flex items-center gap-3 text-[#c9a227]"><FileCheck2 className="h-6 w-6" /><span className="text-xs font-bold uppercase tracking-[0.2em]">Home Smart · {version}</span></div>
          <h1 className="mt-4 text-4xl font-extrabold leading-tight sm:text-5xl" style={{ fontFamily: 'Georgia, serif' }} data-testid={`${testId}-title`}>{title}</h1>
          <p className="mt-4 max-w-2xl text-base font-semibold text-[#dbe5f3]" data-testid={`${testId}-subtitle`}>{subtitle}</p>
        </header>
        <div className="space-y-9 px-6 py-9 sm:px-10 sm:py-12">{children}</div>
      </article>
      <p className="mx-auto mt-5 max-w-3xl text-center text-xs leading-relaxed text-[#64748b]" data-testid={`${testId}-review-note`}>Documento predisposto come base operativa originale per Home Smart. Prima dell’uso commerciale definitivo è raccomandata la revisione di un professionista legale qualificato nelle giurisdizioni interessate.</p>
    </div>
  </main>
);

export const LegalSection = ({ number, title, children, testId }) => (
  <section className="space-y-3" data-testid={testId}>
    <h2 className="text-lg font-extrabold text-[#08234c]">{number}. {title}</h2>
    <div className="space-y-3 text-sm leading-7 text-[#44597e]">{children}</div>
  </section>
);